import { ParsedQuery } from "query-string";

export const isAnyWhereModalPopped = (parsedSearch: ParsedQuery): boolean =>
  !!(parsedSearch.signUp || parsedSearch.signIn || parsedSearch.product);
